import Axios from 'axios';

const baseURL = 'https://viacep.com.br/ws';
const responseFormat = 'json';

export const ZIPCODE = async (zipCode) => {
	return await Axios.get(`${baseURL}/${zipCode}/${responseFormat}`);
};
